export const generatePageTitle = ({
  title,
  networkName,
  topicName,
}: {
  title: string;
  networkName?: string;
  topicName?: string;
}) => {
  const rightPart = topicName || networkName;

  return [title, rightPart].filter(Boolean).join(' | ');
};
